var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "np_info_118049_000000 1",
    clipPath: "url(#clip0_6120_13168)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.33114 1.52588e-05C2.38575 1.52588e-05 -0.00219727 2.38796 -0.00219727 5.33335C-0.00219727 8.27874 2.38575 10.6667 5.33114 10.6667C8.27653 10.6667 10.6645 8.27874 10.6645 5.33335C10.6645 2.38796 8.27653 1.52588e-05 5.33114 1.52588e-05ZM5.2203 1.91874C5.59447 1.91874 5.91072 2.2254 5.91072 2.60916C5.91072 2.9925 5.59405 3.29958 5.2203 3.29958C4.84655 3.29958 4.5303 2.99291 4.5303 2.60916C4.52988 2.2254 4.84654 1.91874 5.2203 1.91874ZM6.76409 8.39085H3.95449V7.75793H4.39532C4.66407 7.75793 4.77908 7.65251 4.77908 7.37417V4.91956C4.77908 4.64164 4.66408 4.53622 4.39532 4.53622H3.95449V3.9033H5.91076V7.37413C5.91076 7.65205 6.02575 7.75789 6.29409 7.75789H6.76409V8.39085Z",
    fill: "#D3D3D3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6120_13168"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.6667,
    height: 10.6667,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.3f2a23ab5c1c30409a1bce949785e2f3.svg";
export { ForwardRef as ReactComponent };